import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { useAlert } from 'components/Shared/Alert'
import { ParticipantProfileContext } from 'containers/ParticipantProfile'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import participantAPI from 'api/ApiActions/Participant/Participant'
import { handleSubscribe } from 'components/ParticipantProfile/ActionButtons/Buttons/SubscribeToNewsletters/Helper'

interface SubscribeToNewslettersProps {
  isOpen: boolean
  setModalVisibility: (arg0: boolean) => void
}

const SubscribeToNewsletters = ({
  isOpen,
  setModalVisibility,
}: SubscribeToNewslettersProps) => {
  const { state, functions } = React.useContext(ParticipantProfileContext)
  const { participantSummary } = state
  const { getParticipant } = functions
  const { login, id } = participantSummary
  const { t } = useTranslation()
  const { showAlert } = useAlert()
  const theme: AdminUITheme = useTheme()
  const [sending, onSending] = React.useState(false)

  const handleClose = () => {
    setModalVisibility(false)
  }

  const handleError = () => {
    showAlert({ type: 'error', title: t('alert.error.400') })
  }

  const handleSuccess = () => {
    showAlert({
      type: 'success',
      title: t(
        'participant.PRMActionButtons.participantDetails.success_alerts.susbscribeToNewsletter',
      ),
    })
  }

  const handleClick = () => {
    handleSubscribe(
      onSending,
      participantAPI,
      handleSuccess,
      handleClose,
      getParticipant,
      handleError,
      id,
    )
  }

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h5" gutterBottom>
          {t('participant.suscribeParticipants.title', {
            login: login,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent sx={theme.Participant.makeProjectAdminContent}>
        <Stack spacing={3}>
          <Typography variant="body1" gutterBottom>
            {t('participant.suscribeParticipants.paraOne')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('participant.suscribeParticipants.paraTwo')}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={theme.Participant.makeProjectAdminContentActions}>
        <Button
          sx={theme.Participant.makeProjectAdminDialogCancelBtnDesk}
          variant="text"
          onClick={handleClose}
        >
          {t('participant.suscribeParticipants.cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={handleClick}
          disabled={sending}
          data-testid="make-project-admin-yes"
        >
          {sending && <CircularProgress size={20} sx={{ mr: 1 }} />}
          {t('participant.suscribeParticipants.subscribe')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SubscribeToNewsletters
